import {InlineModuleTypeEnum} from "../Views/PageView/Enums/InlineModuleTypeEnum";

export function convertedHtmlArray(html: string, forms: any[], documents: any[], components: []) {
	let result = [];
	const regex = /\[.+?\]/g;

	if (html.match(regex)) {
		let str = html;
		let index = 0;

		[...str.matchAll(regex)].forEach(item => {
			result.push(str.slice(index, item.index));
			const match = item[0].match(/\[([^:]+):?([^\]]+)?\]/);

			if (!match) {
				result.push(item[0]);
			} else {
				const [, type, itemId] = match;

				if (type === InlineModuleTypeEnum.RECALL && itemId === undefined) {
					result.push({type: InlineModuleTypeEnum.RECALL});
				} else if (type === InlineModuleTypeEnum.FORM && forms) {
					result.push({type: InlineModuleTypeEnum.FORM, items: forms[itemId]});
				} else if (type === InlineModuleTypeEnum.DOCUMENT && documents) {
					result.push({type: InlineModuleTypeEnum.DOCUMENT, items: documents[itemId]});
				} else if (type === InlineModuleTypeEnum.COMPONENT && components) {
					result.push({type: InlineModuleTypeEnum.COMPONENT, items: components[itemId]});
				} else {
					result.push(item[0]);
				}
			}
			index = item.index + item[0].length;
		});

		result.push(str.slice(index));
	} else {
		result.push(html);
	}
	return result;
}

